import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import { Button } from 'components/Button/RoundButton';
import { userRoles } from 'constants/users';
import { useActions } from 'hooks/useActions';
import { useAppContext } from 'hooks/useContext';
import { useIsScrolled } from 'hooks/useIsScrolled';
import {
  HeaderWrapper,
  HeaderContainer,
  Logo,
  NavigationContainer,
  Link,
  MenuIcon,
  LinkContainer,
  ProfileAvatar,
  ProfileAvatarContainer,
} from './styles';
import FlagDropdown from './FlagDropdown';
import * as strings from './strings';
import * as authActions from 'global/actions/authActions';
import Path from 'routes/Path';

const communityRoutes = ['/challenges', '/exercises', '/freecode', '/profile', '/courses'];

export default function HeaderCommunity() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [isOpened, setIsOpened] = useState(false);
  const [headerLinks, setHeaderLinks] = useState(strings.FRONT_LINKS);
  const isScrolled = useIsScrolled();

  const {
    userRole,
    token,
    isCommunityUser,
    isTicketAuth,
    user: { avatar },
  } = useSelector((state) => state.auth);
  const { logout } = useActions(authActions);

  const isCommunity = () => communityRoutes.some((path) => pathname.includes(path));

  useEffect(() => {
    if (pathname === Path.companyPage) {
      setHeaderLinks(strings.COMPANY_PAGE_LINKS);
    } else if (userRole && userRole !== userRoles.CANDIDATE) {
      setHeaderLinks([...strings.FRONT_LINKS, ...strings.ADMIN_LINKS()]);
    } else {
      setHeaderLinks(strings.FRONT_LINKS);
    }
  }, [userRole, pathname]);

  const LOGIN_BUTTONS = token ? strings.LOGGED_IN_BUTTONS(logout) : strings.NOT_LOGGED_IN_BUTTONS;

  const BUTTONS =
    pathname === Path.companyPage
      ? [...strings.FOR_DEV_BUTTONS, ...LOGIN_BUTTONS]
      : [...strings.BASE_BUTTONS, ...LOGIN_BUTTONS];

  const { language, setLanguage } = useAppContext();

  // Automatically closes menu if pathname or language changes (only happens on smaller resolutions)
  useEffect(() => {
    setIsOpened(false);
  }, [pathname, language]);

  const redirectUser = () => {
    if (isTicketAuth) navigate('/tickets');
    else navigate('/');
  };

  return (
    <HeaderWrapper isScrolled={isScrolled} isOpened={isOpened}>
      <HeaderContainer>
        <Logo onClick={() => redirectUser()} />
        <MenuIcon onClick={() => setIsOpened(!isOpened)} />
        <NavigationContainer isOpened={isOpened}>
          <LinkContainer>
            {headerLinks.map((link) => {
              return (
                <Link key={`${link[language].replace(' ', '-').toLowerCase()}-${link.to}`} to={link.to}>
                  {link[language]}
                </Link>
              );
            })}
            {BUTTONS.map((button) => {
              const btn = (
                <Button
                  primary={button.style === 'primary'}
                  secondary={button.style === 'secondary'}
                  isMenu
                  isScrolled={isScrolled}
                  onClick={button.func}
                  removeMargin
                  key={button.func ? button[language].toLowerCase() : undefined}
                >
                  {button[language]}
                </Button>
              );

              if (button.func) {
                return btn;
              }

              return (
                <Link key={`${button[language].replace(' ', '-').toLowerCase()}-${button.to}`} to={button.to}>
                  {btn}
                </Link>
              );
            })}
          </LinkContainer>
          {isCommunityUser && (
            <Link to={Path.profilePage}>
              <ProfileAvatarContainer isScrolled={isScrolled}>
                {/* <ProfileExperience experience={experiencePercent} /> */}
                <ProfileAvatar image={avatar} />
                {/* <ProfileExperienceText>
                  {experiencePercent}%
                </ProfileExperienceText> */}
              </ProfileAvatarContainer>
            </Link>
          )}
          {!isCommunity() && <FlagDropdown language={language} setLanguage={setLanguage} />}
        </NavigationContainer>
      </HeaderContainer>
    </HeaderWrapper>
  );
}
